// /patient/message — send a message. Who / what radios, textarea, recent
// replies. Saves locally for now (no clinic-message backend table yet).
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { doctorLabel, usePatientData } from "./PatientDataContext";
import { MOCK_REPLIES } from "./patientMockData";

const WHO_OPTIONS = [
  "Dr. Pallickal & Norinne (clinic team)",
  "Norinne (nurse) only",
  "Dr. Pallickal only",
  "Front desk / scheduling",
];

const ABOUT_OPTIONS = [
  "A general question",
  "I want to request an appointment",
  "I'm not feeling well",
  "Medicine refill",
  "Question about lab results",
];

const DEFAULT_BODY =
  "Dr. Pallickal, I have been feeling well this week. No chest pain. I am still walking 20 minutes most days. Quick question: can I take the new medicine with my morning coffee? Thank you, Alex";

export default function PatientMessage() {
  const { rows } = usePatientData();
  const location = useLocation();
  const initialAbout = location.state?.about || "A general question";
  const doctor = doctorLabel(rows[0] || {});

  const [who, setWho] = useState(WHO_OPTIONS[0]);
  const [about, setAbout] = useState(initialAbout);
  const [body, setBody] = useState(DEFAULT_BODY);
  const [sent, setSent] = useState(false);

  const handleSend = (e) => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => setSent(false), 2500);
  };

  return (
    <>
      <div className="pp-page-head">
        <Link to="." className="pp-back-link">‹ Home</Link>
        <h1 className="pp-page-title">Send a message</h1>
        <div className="pp-page-sub">
          Norinne & {doctor} will see it
        </div>
      </div>

      <div className="pp-card">
        <div className="pp-msg-helper">
          <span>✨</span>
          <div>
            <strong>Need help writing this?</strong>
            <div>The VitaMed Helper can talk to your doctor for you.</div>
          </div>
          <Link to="wizard" className="pp-btn pp-ghost pp-btn-compact">
            Ask
          </Link>
        </div>

        <form className="pp-msg-form" onSubmit={handleSend}>
          <fieldset className="pp-radio-group">
            <legend className="pp-input-lbl">Who is this for?</legend>
            {WHO_OPTIONS.map((opt) => (
              <label key={opt} className="pp-radio">
                <input
                  type="radio"
                  name="who"
                  value={opt}
                  checked={who === opt}
                  onChange={(e) => setWho(e.target.value)}
                />
                <span>{opt}</span>
              </label>
            ))}
          </fieldset>

          <fieldset className="pp-radio-group">
            <legend className="pp-input-lbl">What is this about?</legend>
            {ABOUT_OPTIONS.map((opt) => (
              <label key={opt} className="pp-radio">
                <input
                  type="radio"
                  name="about"
                  value={opt}
                  checked={about === opt}
                  onChange={(e) => setAbout(e.target.value)}
                />
                <span>{opt}</span>
              </label>
            ))}
          </fieldset>

          <label className="pp-input">
            <span className="pp-input-lbl">Your message</span>
            <textarea
              rows={6}
              value={body}
              onChange={(e) => setBody(e.target.value)}
            />
          </label>

          <p
            className="pp-detail-p"
            style={{ marginTop: -4, color: "var(--pp-subtle)" }}
          >
            It is okay to use plain words. Your clinic team will understand.
          </p>

          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            <button type="submit" className="pp-btn pp-teal">
              ✓ Send message
            </button>
            <button type="button" className="pp-btn pp-ghost">
              Save as draft
            </button>
          </div>
          {sent && (
            <div className="pp-saved-flash">
              Sent — your clinic team will reply soon.
            </div>
          )}
        </form>
      </div>

      <div className="pp-section-title">Recent replies</div>
      {MOCK_REPLIES.map((r) => (
        <div className="pp-reply" key={r.who + r.date}>
          <div className="pp-reply-avatar">{r.initial}</div>
          <div className="pp-reply-body">
            <div className="pp-reply-who">{r.who}</div>
            <div className="pp-reply-text">{r.text}</div>
            <div className="pp-reply-date">{r.date}</div>
          </div>
        </div>
      ))}
    </>
  );
}